import React, {Component} from "react";
import {BILATERAL_CONTROL_PANEL_ROUTE} from "../../../../utils/constants/RoutesConstants";
import BilateralMoveTitleCollateral from "./BilateralMoveTitleCollateralView";
import {Growl} from "primereact/growl";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";
import {InstructionService} from "../../../../service/bilateral/loan/InstructionService";

export default class BilateralMoveTitleCollateralContainer extends Component {
    constructor(props) {
        super(props);
        this.ACTION_MAP = {
            'T': 'Traspaso',
            'R': 'Regreso' };

        this.bilateralLoanService = new BilateralLoanService();
        this.instructionService = new InstructionService();
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.showRejectDialog = this.showRejectDialog.bind(this);
        this.handleRefuse = this.handleRefuse.bind(this);
        this.setPendingInstructions = this.setPendingInstructions.bind(this);
        this.setProfileType = this.setProfileType.bind(this);
        this.validSettlementFolios = this.validSettlementFolios.bind(this);
        this.saveSettlementFolios = this.saveSettlementFolios.bind(this);
        this.getInstructionListForBothProfile = this.getInstructionListForBothProfile.bind(this);
        this.getInstructionListForLender = this.getInstructionListForLender.bind(this);
        this.getInstructionListForBorrower = this.getInstructionListForBorrower.bind(this);
        this.validateAndSaveInstructions = this.validateAndSaveInstructions.bind(this);

        this.getAction = this.getAction.bind(this);
        this.getInstructions = this.getInstructions.bind(this);

        this.folioGuaranteeEditor = this.folioGuaranteeEditor.bind(this);
        this.onEditorGuaranteeValueChange = this.onEditorGuaranteeValueChange.bind(this);
        this.folioTitleEditor = this.folioTitleEditor.bind(this);
        this.onEditorTitleValueChange = this.onEditorTitleValueChange.bind(this);
        this.folioPremiumEditor = this.folioPremiumEditor.bind(this);
        this.onEditorPremiumValueChange = this.onEditorPremiumValueChange.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.saveMessage = this.saveMessage.bind(this)
        this.setShowCollateralTable = this.setShowCollateralTable.bind(this);
        this.setShowTitleTable = this.setShowTitleTable.bind(this);
        this.setShowPremiumTable = this.setShowPremiumTable.bind(this);

        this.state = {
            isLoading: false,
            displayDialog: false,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            status: '',
            action: '',
            loan: [],
            loanInstructionsCollateral: [],
            loanInstructionsTitle: [],
            loanInstructionsPremium: [],
            isLender: false,
            isBorrower: false,
            rejectMessage: '',
            showCollateralTable: false,
            showTitleTable: false,
            showPremiumTable:false
        };
    }

    componentDidMount (){
        this.getAction();
        this.getInstructions();
        this.setProfileType()
    }

    getInstructions() {
        this.loading(true)
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.bilateralLoanService.getLoanInstructions(loanId)
            .then( res => {
                if (this.validResponse(res)){
                   this.setPendingInstructions(res.data)
                }
                this.setShowCollateralTable();
                this.setShowTitleTable();
                this.setShowPremiumTable();
                this.loading(false)
            });
    }
    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    setProfileType(){
        let loggedInstitution = localStorage.getItem("institution");
        const {lender, borrower} = this.props.location.state.selectedLoanControlPanel;
        this.setState({
            isLender: this.isSameInstitution(loggedInstitution, lender),
            isBorrower: this.isSameInstitution(loggedInstitution, borrower),
            isBoth: this.isSameInstitution(loggedInstitution, lender)
                && this.isSameInstitution(loggedInstitution, borrower)
        })
    }

    isSameInstitution(sourceInst, targetInst) {
        return sourceInst === targetInst
    }

    setPendingInstructions(instructionList) {
        let rate = this.props.location.state.selectedLoanControlPanel?.rate;

        const {collateralList, titleList, premiumList} = instructionList.reduce(
            (accumulator, item) => {
                if (item['instrumentType'] === 'COLLATERAL') {
                    accumulator.collateralList.push(item);
                } else if (item['instrumentType'] === 'TITLE') {
                    accumulator.titleList.push({ ...item, rate});
                } else {
                    accumulator.premiumList.push(item);
                }
                return accumulator;
            },
            { collateralList: [], titleList: [], premiumList: [] }
        );
        this.setState({
            loanInstructionsCollateral: collateralList,
            loanInstructionsTitle: titleList,
            loanInstructionsPremium: premiumList,
        })
    }

    getAction() {
        const status = this.props.location.state?.selectedLoanControlPanel?.status;
        const action = this.ACTION_MAP[status] || '';
        this.setState({
            action: action
        });
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
            message: message,
        });
    }

    onEditorGuaranteeValueChange(props, value) {
        let guarantee = [...props.value];
        guarantee[props.rowIndex][props.field] = value;
        this.setState({loanInstructionsCollateral: guarantee});
    }

    folioGuaranteeEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.settlementFolio}
            thousandSeparator={false} allowNegative={false} allowEmptyFormatting={true}
            maxLength={18} keyfilter="pint" allowLeadingZeros={true}
            onChange={(e) => this.onEditorGuaranteeValueChange(props, e.target.value)}
        />;
    }

    onEditorTitleValueChange(props, value) {
        let title = [...props.value];
        title[props.rowIndex][props.field] = value;
        this.setState({loanInstructionsTitle: title});
    }

    folioTitleEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.settlementFolio}
            thousandSeparator={false} allowNegative={false} allowEmptyFormatting={true}
            maxLength={18} keyfilter="pint" allowLeadingZeros={true}
            onChange={(e) => this.onEditorTitleValueChange(props, e.target.value)}
        />;
    }
    folioPremiumEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.settlementFolio}
            thousandSeparator={false} allowNegative={false} allowEmptyFormatting={true}
            maxLength={18} keyfilter="pint" allowLeadingZeros={true}
            onChange={(e) => this.onEditorPremiumValueChange(props, e.target.value)}
        />;
    }
    onEditorPremiumValueChange(props, value) {
        let premium = [...props.value];
        premium[props.rowIndex][props.field] = value;
        this.setState({loanInstructionsPremium: premium});
    }

    handleAgree() {
        const {isBorrower, isLender, isBoth} = this.state;
        let combinedInstructionList = [];
        if (isBoth) {
            combinedInstructionList = this.getInstructionListForBothProfile();
        } else if (isLender) {
            combinedInstructionList = this.getInstructionListForLender()
        } else if (isBorrower) {
            combinedInstructionList = this.getInstructionListForBorrower();
        }
        this.validateAndSaveInstructions(combinedInstructionList);
    }

    getInstructionListForBothProfile() {
        const {action, loanInstructionsCollateral,
            loanInstructionsTitle, loanInstructionsPremium} = this.state;
        let combinedInstructionList;
        switch (action) {
            case this.ACTION_MAP["T"]:
                combinedInstructionList = loanInstructionsCollateral.concat(loanInstructionsTitle);
                break;
            case this.ACTION_MAP["R"]:
                combinedInstructionList = loanInstructionsCollateral.concat(loanInstructionsPremium)
                    .concat(loanInstructionsTitle);
                break
            default:
                combinedInstructionList = [];
        }
        return combinedInstructionList;
    }

    getInstructionListForLender() {
        const {action, loanInstructionsCollateral, loanInstructionsTitle} = this.state;
        let combinedInstructionList;
        switch (action) {
            case this.ACTION_MAP["T"]:
                combinedInstructionList = loanInstructionsTitle;
                break;
            case this.ACTION_MAP["R"]:
                combinedInstructionList = loanInstructionsCollateral;
                break
            default:
                combinedInstructionList = [];
        }
        return combinedInstructionList;
    }

    getInstructionListForBorrower() {
        const {action, loanInstructionsCollateral,
            loanInstructionsTitle, loanInstructionsPremium, selectedLoan} = this.state;
        let combinedInstructionList;
        switch (action) {
            case this.ACTION_MAP["T"]:
                combinedInstructionList = loanInstructionsCollateral;
                break;
            case this.ACTION_MAP["R"]:
                combinedInstructionList = selectedLoan.flow === "Exceso"
                    ? loanInstructionsCollateral : loanInstructionsTitle.concat(loanInstructionsPremium);
                break
            default:
                combinedInstructionList = [];
        }
        return combinedInstructionList;
    }

    validateAndSaveInstructions(instructionsToUpdate) {
        if (instructionsToUpdate.length > 0 && this.validSettlementFolios(instructionsToUpdate)) {
            this.saveSettlementFolios(instructionsToUpdate);
        }
    }

    saveSettlementFolios(instructionList) {
        this.loading(true);
        let params= {
            loanId: this.state.selectedLoan.id,
            folioList: this.makeFoliosList(instructionList)
        }
        this.instructionService.saveSettlementFolios(params).then( res => {
            if (this.validResponse(res)){
                this.handleReturnButton({
                    severity: 'success',
                    sumary: 'Éxito',
                    detail: 'Los folios han sido guardados exitosamente.',
                });
            }
            this.loading(false)
        });
    }

    makeFoliosList(instructionList) {
        return instructionList.map((item) => ({
            id: item.id,
            settlementFolio: item.settlementFolio
        }));
    }

    validSettlementFolios(instructionList) {
        for (const item of instructionList) {
            if(!this.validFolio(item['settlementFolio'])) {
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: "Debe especificar todos los Folios."});
                return false;
            }
        }
        return true;
    }

    validFolio(folio) {
        return !(folio === undefined || folio === "");
    }

    handleRefuse() {
        if (this.state.rejectMessage === '') {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de poner un mensaje"});
        } else {
            alert("Funcionalidad en proceso")
        }
    }

    onHideDialog() {
        this.setState({
            displayDialog: false,
            rejectMessage: ''
        });
    }

    showRejectDialog() {
        this.setState({displayDialog: true,});
    }

    saveMessage(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    setShowCollateralTable() {
        const {isLender, isBorrower, action, loanInstructionsCollateral} = this.state;
        const {flow} = this.props.location.state.selectedLoanControlPanel;
        let instructionsLength = loanInstructionsCollateral.length;
        let showTableByAction = false;

        switch (action) {
            case this.ACTION_MAP["T"]:
                showTableByAction = isBorrower;
                break;
            case this.ACTION_MAP["R"]:
                showTableByAction = this.getCollateralReturnValidation(isLender, isBorrower, flow);
                break
            default:
                showTableByAction = false;
        }
        let showCollateralTable = showTableByAction && (instructionsLength > 0);
        this.setState({
            showCollateralTable: showCollateralTable
        });
    }

    getCollateralReturnValidation(isLender, isBorrower, flow) {
        return flow === "Exceso" ? isBorrower : isLender;
    }

    setShowTitleTable() {
        const {isLender, isBorrower, action, loanInstructionsTitle} = this.state;
        let instructionsLength = loanInstructionsTitle.length;

        let showTitleTable = ((isLender && action === "Traspaso") ||
                (isBorrower && action === "Regreso")) && (instructionsLength > 0);

        this.setState({
            showTitleTable: showTitleTable
        });
    }

    setShowPremiumTable() {
        const {isBorrower, action, loanInstructionsPremium} = this.state;
        let instructionsLength = loanInstructionsPremium.length;
        let showPremiumTable = isBorrower && action === "Regreso" && instructionsLength > 0;
        this.setState({
            showPremiumTable: showPremiumTable
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralMoveTitleCollateral
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            displayDialog={this.state.displayDialog}
            action={this.state.action}
            loanInstructionsCollateral={this.state.loanInstructionsCollateral}
            loanInstructionsTitle={this.state.loanInstructionsTitle}
            loanInstructionsPremium={this.state.loanInstructionsPremium}
            rejectMessage={this.state.rejectMessage}
            showCollateralTable = {this.state.showCollateralTable}
            showTitleTable = {this.state.showTitleTable}
            showPremiumTable = {this.state.showPremiumTable}
            handleReturnButton={this.handleReturnButton}
            handleAgree={this.handleAgree}
            handleRefuse={this.handleRefuse}
            showRejectDialog={this.showRejectDialog}
            onHideDialog={this.onHideDialog}
            folioGuaranteeEditor={this.folioGuaranteeEditor}
            folioTitleEditor={this.folioTitleEditor}
            folioPremiumEditor={this.folioPremiumEditor}
            saveMessage={this.saveMessage}
        />

    }
};
BilateralMoveTitleCollateralContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};